import { Button } from "@component";
import { Box, styled } from "@mui/material";

export const StyledContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  marginTop: theme.spacing(6),
}));

export const StyledBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "80vh",
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  border: "1px solid",
  width: "10%",
  borderRadius: theme.spacing(0),
  marginTop: theme.spacing(4),
  [theme.breakpoints.down("lg")]: {
    width: "27%",
  },
  "&:hover": {
    backgroundColor: "#1976d2",
  },
}));
